import {Module, Component} from '../decorators';
import _ from "lodash";
import 'app/selector/selector';

import tpl from './ship.to.picker.html';


@Module({
    name: "app.orders.compontents.shipTo",
    modules: [
        'selector',
    ]
})
@Component({
    selector: 'blnd-ship-to',
    template: tpl,
    bindings: {
        ngModel: '=',
        customer: '=',
        mode: '@',
        ngChange: '&?',
    },
})
export default class C {
    constructor ($scope, $element, FieldStore) {
        "ngInject";
        this.store = FieldStore;
        this.scope = $scope;
        this.$element = $element;
        this.creating = false;
        this.watcher = null;
    }

    $onInit() {
        let self = this;
        this.watcher = this.scope.$watch(() => this.ngModel.length, function (newValue, oldValue) {
            if (newValue === oldValue) {return }
            self.triggerChange();
        });
    }

    $onDestroy () {
        this.watcher();
        this.$element.remove();
        this.store = [];
        this.watcher = null;
        this.$element = null;
    }

    customOptionComparator (option, value) {
        // It's faster then comparing whole object
        return option.field.id == value.field.id;
    }

    refresh(search) {
        this.store.init();
        this.store.params.customer = this.customer.id;
        this.store.params.name = search;
        return this.store.refresh().then((resp) => {
            let fields = resp.list.plain();
            return fields.map(o => {
               return { field: o };
            });
        });
    }

    create(input) {
        let self = this;
        if (this.creating) {
            return;
        }

        this.creating = true;
        let data = _.extend({
            customer: this.customer.id,
            geo: {
                latitude: 0.0,
                longitude: 0.0,
            },
        }, input);
        return this.store.create(data).then(function (resp) {
            resp = resp.plain();
            return {
                field: resp
            };
        }).finally(() => {
            self.creating = false;
        });
    }

    triggerChange () {
        if (this.ngChange) {
            this.ngChange();
        }
    }

    get shipTo () {
        if (this.ngModel.length === 0) {
            return '-';
        }
        let fields = _.groupBy(this.ngModel, 'field.farm_name');
        return _.map(fields, function (value, key) {
            let fields = _.map(value, obj => { return `${obj.field.field_name}-${obj.field.acres}`; }).join(', ');
            if (fields) {
                return `${key}: ${fields}`;
            }
            return key;
        }).join(', ');
    }

}



// WEBPACK FOOTER //
// ./src/app/directives/ship.to.picker.js